<template>
    <section class="inAboutconBox">
            <div class="wrapper">
                  <section class="inAboutProfile">
                      <div class="inAboutProfile_word">
                            <div class="title">{{homeAbout.title}}</div>
                            <div class="descSmall">
                                 {{homeAbout.description}}
                            </div>
                            <div class="descBig" v-html="homeAbout.content">
                            </div>
                      </div>
                      <div class="inAboutProfile_img">
                          <img v-if="homeAbout.ext_othimg" :src="$root.$TEMP_URL+homeAbout.ext_othimg" />
                      </div>
                  </section>

                  <section class="inAboutFive">
                        <div class="inAboutFive_iconItem">
                            <div class="iconItemImg">
                                <img src="./images/01.png" />
                            </div>
                            <div class="iconItemText" v-html="isZhong?lableInfo.culture1cn:lableInfo.culture1">
                            </div>
                        </div>
                        <div class="inAboutFive_iconItem">
                            <div class="iconItemImg">
                                <img src="./images/02.png" />
                            </div>
                            <div class="iconItemText" v-html="isZhong?lableInfo.culture2cn:lableInfo.culture2">
                                
                            </div>
                        </div>
                        <div class="inAboutFive_iconItem">
                            <div class="iconItemImg">
                                <img src="./images/03.png" />
                            </div>
                            <div class="iconItemText" v-html="isZhong?lableInfo.culture3cn:lableInfo.culture3">
                               
                            </div>
                        </div>
                        <div class="inAboutFive_iconItem">
                            <div class="iconItemImg">
                                <img src="./images/04.png" />
                            </div>
                            <div class="iconItemText" v-html="isZhong?lableInfo.culture4cn:lableInfo.culture4">
                                
                            </div>
                        </div>
                        <div class="inAboutFive_iconItem">
                            <div class="iconItemImg">
                                <img src="./images/05.png" />
                            </div>
                            <div class="iconItemText"  v-html="isZhong?lableInfo.culture5cn:lableInfo.culture5">
                                
                            </div>
                        </div>
                  </section>

                  <section class="inAboutEndText" v-text="isZhong?lableInfo.profileBottomcn:lableInfo.profileBottom" >
                  </section>
            </div>
        </section>
</template>

<script>
import {getHomeAbout,getLable,getHomeAboutcn} from '../../../api'
export default {
    data() {
        return {
            homeAbout:{},
            lableInfo:{},
            isZhong:false

        };
    },
    async created(){

        const isZhong = this.$parent.isZhong;
        this.isZhong =isZhong;
        let res;

        if(isZhong){
            res = await getHomeAboutcn();
        }else{
            res = await getHomeAbout();
        }

        const homeAbout = res.data;
        this.homeAbout = homeAbout;
        //自定义标签
        const resLab = await getLable();
        const lableInfo = resLab.data;
        this.lableInfo =lableInfo;
    }
   
};
</script>

<style lang="scss" scoped>
@import '../../../common/css/mixin.scss';
.inAboutconBox {
   background: #fafdfd;  
   padding: 82px 0;
  .wrapper {
    .inAboutProfile {
      @include flexFather;
      .inAboutProfile_word {
        width: 50%;  
        margin-top: 38px;
        .title {
            height: 44px;
            line-height: 44px;
            font-size: 30px;
            color: $themeColor;
            font-weight: bold;
        }

        .descSmall {
            font-size: 18px;
            line-height: 32px;
            color: $themeColor;
            margin-bottom: 28px;
            padding-right: 72px;
            margin-top: 4px;
        }

        .descBig {
            line-height: 30px;
        }
      }

      .inAboutProfile_img {
        width: 468px;  
        margin: 78px 98px 0 0;
        position: relative;
        z-index: 2;
        img {
            width: 100%;
            height: 468px;
        }
        &::before{
            content: "";
            width: 200px;
            height: 400px;
            background: $themeColor;
            position: absolute;
            right: -98px;
            top: -78px;
            z-index: -1;
        }
      }
    }

    .inAboutFive {
      margin: 44px 0 38px 0; 
      display: flex;
      justify-content: space-around;
      align-items: center;
      background: url(./images/beijing_def.jpg) no-repeat;
      height: 236px;
      .inAboutFive_iconItem {
        .iconItemImg {
          img {
              width: 75px;
              height: 75px;
          }
        }
        .iconItemText {
           margin-top: 12px;
           line-height: 28px;
           height: 56px;
           color: #fff;
           overflow: hidden;
        }
      }
    }

    .inAboutEndText {
        line-height: 28px;

    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/About/Profile/Profile.vue